import React from 'react';
import { View, StyleSheet, ScrollView, Image } from 'react-native';
import { Button, Card, CardCaption, CardContainer, Colors, getSpacing, Rating, Text } from '@rahtab/ui';
import { RouteProp } from '@react-navigation/native';
import { RootStackType } from '../../Router';
import { StackNavigationProp } from '@react-navigation/stack';
import { Screen } from '@rahtab/stack-navigator';
import useLinkBuilder from '../../hooks/useLinkBuilder';
import ChevronLeftIcon from '@rahtab/ui/dist/icons/ChevronLeftIcon';
// import { useMerchandise } from './useMerchandise';
// import { StoresSortType } from 'screens/Stores';

type MerchandiseNavigationProp = StackNavigationProp<RootStackType, 'Merchandise'>;
interface MerchandiseInfoProps {
  navigation: MerchandiseNavigationProp;
  route: RouteProp<RootStackType, 'Merchandise'>;
}

const Merchandise: React.FC<MerchandiseInfoProps> = ({ route }) => {
  const { name, image, distDate, distType, price, available } = route.params;
  const linkBuilder = useLinkBuilder<RootStackType>();
  return (
    <Screen
      // loading={loading}
      title="مشخصات کالا"
      renderMain={() => {
        return (
          <ScrollView>
            <View style={{ margin: getSpacing(0.5) }}>
              <Card style={styles.card}>
                <Image source={{ uri: image }} style={styles.MerchandiseIcon} resizeMode="contain" />
              </Card>
              <Card style={styles.card}>
                <CardContainer>
                  <Text color="primary" variant="title">
                    {name}
                  </Text>
                  <Text style={styles.grayText}>
                    نوع عرضه: <Text variant="cardTitle">{distType}</Text>
                  </Text>
                  <Text style={styles.grayText}>
                    تاریخ عرضه: <Text variant="cardTitle">{distDate}</Text>
                  </Text>
                  <Text style={styles.grayText}>
                    قیمت واحد: <Text variant="cardTitle">{price} تومان</Text>
                  </Text>
                  {/* <Text style={styles.grayText}>
                    رضایتمندی از کالا: <Rating value={ratings.totalRating} count={ratings.totalCount} />
                  </Text> */}
                </CardContainer>
                <CardCaption color="primary" style={styles.caption}>
                  <Text margin="none" color="white">
                    موجودی عرضه
                  </Text>
                  <Text margin="none" color="white" variant="cardTitle">
                    {available}
                  </Text>
                </CardCaption>
              </Card>
              <Button linkUrl={linkBuilder('LoadsList')} variant="outlined" color="primary" style={styles.button}>
                <Text margin="none" variant="mediumBody" color="primary">
                  مشاهده بارهای دریافتی موجود از این کالا
                </Text>
                <ChevronLeftIcon stroke={Colors.primary} />
              </Button>
            </View>
          </ScrollView>
        );
      }}
    />
  );
};

export default Merchandise;

const styles = StyleSheet.create({
  card: {
    margin: getSpacing(0.5),
  },
  MerchandiseIcon: {
    height: 170,
    width: 260,
    marginVertical: 30,
    alignSelf: 'center',
  },
  grayText: {
    color: Colors.midGray,
  },
  caption: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  chevron: {
    height: 8,
    width: 8,
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: getSpacing(0.5),
    paddingHorizontal: getSpacing(),
  },
});
